export default import.meta.ROLLDOWN_FILE_URL_SH3JcDOvWNcn2WIvxBnLpg